import { SVGProps } from 'react';

const UserLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.3 15H7a4 4 0 0 0-4 4v2m12-5.5V14a2 2 0 0 1 4 0v1.5M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-.101 9h6.202c.497 0 .899.402.899.899v3.202a.9.9 0 0 1-.899.899h-6.202a.9.9 0 0 1-.899-.899v-3.202c0-.497.402-.899.899-.899"
    />
  </svg>
);
export default UserLock;
